module.exports = __webpack_public_path__ + "static/media/RefiveOnboardingBackground.f296d8df.png";